module.exports = __webpack_public_path__ + "static/media/loader.26ef8bb4.gif";